export default __webpack_public_path__ + "static/media/chatpate.77441aa0.jpg";